import { apiClient } from "../../../base/ApiClient";

export const exportCouncilBilling = async (filters) => {
  const response = await apiClient.get('/billing/finance/export/', {
    params: filters,
    responseType: 'blob',
  });

  const blob = new Blob([response.data], { 
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
  });
  
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `Council_Actuals_${filters.start_date}.xlsx`);
  document.body.appendChild(link);
  link.click();
  
  link.remove();
  window.URL.revokeObjectURL(url);
  return response.data;
};


/**
 * Fetches the list of all past billing exports.
 * Contains summary info: dates, total jobs, and total amount.
 */
export const getBillingHistory = async (page = 1, pageSize = 10) => {
  const response = await apiClient.get(`/billing/billing-history/?page=${page}&page_size=${pageSize}`);
  return response.data;
};

/**
 * Fetches the detailed audit log for a specific export.
 * This includes the 'calculation_log' JSON with 1hr 10min breakdown and holiday notes.
 */
export const getBillingHistoryDetail = async (id) => {
  const response = await apiClient.get(`/billing/billing-history/${id}/`);
  return response.data;
};

/**
 * Optional: Delete an old history record if needed.
 */
export const deleteBillingHistory = async (id) => {
  const response = await apiClient.delete(`/billing/billing-history/${id}/`);
  return response.data;
};